import { useQuery } from '@tanstack/react-query';

import { queryOptions } from '@/services/query';
import { showApiErrorToast } from '@/services/api';
import { payingAccountsApi } from '@/domain/paySettings/api';
import { paySettingsKeys } from '@/domain/paySettings/queries/keys';

const FORM_STALE = 15 * 60_000;

// One description for create and edit.
export const payingAccountFormQuery = (companyId: string, accountId: string) =>
  queryOptions({
    queryKey: paySettingsKeys.payingAccountForm(companyId, accountId),
    queryFn: () => payingAccountsApi.getForm({ path: { accountId } }),
    enabled: !!companyId && !!accountId,
    staleTime: FORM_STALE,
    cacheTime: FORM_STALE,
    onError: (error) => showApiErrorToast(error),
  });

export const usePayingAccountForm = (companyId: string, accountId: string) =>
  useQuery(payingAccountFormQuery(companyId, accountId));
